'use client'

import { IModalActions, ModalTypes } from '@/types/modal';
import styles from './DownloadCTASticky.module.scss';
import { useContext } from 'react';
import { ModalContext } from '@/context/ModalContext';
import { pushToDataLayer } from '@/helpers/gtag';
import { getGlobalStateValue } from '@/context/utils';


export default function DownloadCTASticky({ associatedPrograms,isWebinar=false }) {

  const { modalDispatch } = useContext(ModalContext)


  if(!associatedPrograms.length)
    return null

  const Custom10PgType = associatedPrograms[0]?.attributes?.BasicDetails?.Custom10PgType || '';
  const specializationText = associatedPrograms[0]?.attributes?.BasicDetails?.SpecializationText || '';
  const brochure =  associatedPrograms[0]?.attributes?.BasicDetails?.Brochure?.data?.attributes?.url || '';
  const programDetails = associatedPrograms[0]?.attributes?.BasicDetails

  const applyNowCTA = () => {
    pushToDataLayer({
      event: "lead_initiate",
      cta_text: isWebinar?"Reserve Now":"Apply Now",
      section_name: "Bottom Navigation Bar",
      page_type: getGlobalStateValue("pageType"),
    });
  
    
    modalDispatch({
      type: IModalActions.OpenModal,
      data: {
        modalType: ModalTypes.ConnectModalLP,
        modalData: {
          associatedPrograms,
          isLandingPage: true
        },
      },
    });
  };

  const downloadBrochureCTA = () => {
    modalDispatch({
      type: IModalActions.OpenModal,
      data: {
        modalType: ModalTypes.DownloadBrochureLP,
        modalData: { specializationText, Custom10PgType, brochure, isMobile: true, programDetails },
      },
    });

    setTimeout(()=>{

      pushToDataLayer({
        event: "lead_initiate",
        cta_text: "Download Brochure",
        section_name: "Bottom Navigation Bar",
        page_type: getGlobalStateValue("pageType"),
      });

      window.webengage.track("Download Brochure Clicked");
      
    },1500)

   
  };

  return (
    <div className={styles.downloadCTAContainer} id="botton-nav-container">
       {!isWebinar ? (
        <>
           <button onClick={downloadBrochureCTA} className={styles.downloadBrochureContainer}>
        Download Brochure
      </button>
      <button onClick={applyNowCTA} className={styles.applyNowContainer}>
      Enquire Now
      </button>
        </>
      ) : (
        <button onClick={applyNowCTA} className={styles.webinarApplyNow}>
          Reserve Your Spot
        </button>
      )}
    </div>
  )
}
